import { User } from './models/user';

export function isLocked(user: User) {
    return user.is_locked;
}